export class OpenDialog {
  static readonly type = '[Confirmation dialog] - Open dialog';

  constructor(public title: string, public content: string) { }
}

export class CloseDialog {
  static readonly type = '[Confirmation dialog] - Close dialog';
}

export class SetCloseResult {
  static readonly type = '[Confirmation dialog] - Set close result';

  constructor(public closeResult: boolean|null) {}
}
